import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import Confetti from 'react-dom-confetti';

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 25px;
  border-radius: 25px;
  border: none;
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 200px;
  font-size: 24pt;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);

  background: rgb(255,79,236);
  background: linear-gradient(90deg, rgba(255,79,236,1) 0%, rgba(255,233,114,1) 100%);
  border: 3px solid white;
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: var(--primary);
  padding: 10px;
  font-weight: bold;
  font-size: 20px;
  color: var(--primary-text);
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ff4ced;
  border: 3px solid white;
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 400px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledSecondButton = styled.img`
  width: 200px;
  cursor: pointer;
  @media (min-width: 767px) {
    width: 400px;
  }
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Your number of free claims is displayed below. \n Click "CLAIM" to mint your UDW NFT's!`);
  const [confetti, setConfetti] = useState(false);
  const [mintAmount, setMintAmount] = useState(0);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mintFree(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setConfetti(true);
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const getMintAmount = () => {
    let a = blockchain.smartContract.methods.addressFreeMintBalance(blockchain.account).call().then((result) => {
      setMintAmount(result);
      console.log('mintAmount', result);
    })
  }

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));

      getMintAmount();
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  const config = {
    angle: 90,
    spread: 360,
    startVelocity: 50,
    elementCount: 200,
    dragFriction: 0.12,
    duration: "4180",
    stagger: 3,
    width: "18px",
    height: "18px",
    perspective: "500px",
    colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"]
  };

  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 24, paddingTop: 0, paddingBottom: 0, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg_new.jpg" : null}
      >
        <StyledLogo alt={"logo"} src={"/config/images/logo_new.png"} />
        <ResponsiveWrapper flex={1} style={{ padding: 24, paddingTop: 24 }} test>
          <Confetti active={ confetti } config={ config }/>
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg alt={"example"} src={"/config/images/gif_1.gif"} />
          </s.Container>
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
            }}
          >
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
              </>
            ) : (
              <>
                <s.SpacerSmall />
                <s.TextTitle style={{ textAlign: "center", color: "#fff", fontFamily: 'Poppins', fontWeight: 800, fontSize: 35 }}>
                  Free Claim Page
                  {/*Price: <b style={{fontWeight: 700}}>{CONFIG.DISPLAY_COST}{" "}{CONFIG.NETWORK.SYMBOL}</b>*/}
                </s.TextTitle>
                <s.SpacerSmall />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: "20pt",
                        maxWidth: "600px",
                        fontWeight: 400,
                        fontFamily: 'Poppins',
                      }}
                    >
                      Please make sure you're <b style={{fontWeight: 700}}>connected</b> to the <b style={{fontWeight: 700}}>ETHEREUM NETWORK</b> with your wallet.
                    </s.TextDescription>
                    <s.SpacerSmall />

                    <StyledButton
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(connect());
                          getData();
                        }}
                    >
                      CONNECT
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "#fff",
                        fontSize: 25
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      {/*<StyledRoundButton*/}
                      {/*  style={{ lineHeight: 0.4 }}*/}
                      {/*  disabled={claimingNft ? 1 : 0}*/}
                      {/*  onClick={(e) => {*/}
                      {/*    e.preventDefault();*/}
                      {/*    decrementMintAmount();*/}
                      {/*  }}*/}
                      {/*>*/}
                      {/*  -*/}
                      {/*</StyledRoundButton>*/}
                      {/*<s.SpacerMedium />*/}
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "#fff",
                          fontWeight: 800,
                          fontSize: 60
                        }}
                      >
                        {mintAmount}
                      </s.TextDescription>
                      {/*<s.SpacerMedium />*/}
                      {/*<StyledRoundButton*/}
                      {/*  disabled={claimingNft ? 1 : 0}*/}
                      {/*  onClick={(e) => {*/}
                      {/*    e.preventDefault();*/}
                      {/*    incrementMintAmount();*/}
                      {/*  }}*/}
                      {/*>*/}
                      {/*  +*/}
                      {/*</StyledRoundButton>*/}
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledButton
                        disabled={(claimingNft ? 1 : 0)}
                        onClick={(e) => {
                          if(mintAmount < 1) {
                            return;
                          }
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "BUSY" : "CLAIM"}
                      </StyledButton>
                    </s.Container>
                  </>
                )}
              </>
            )}
            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg
              alt={"example"}
              src={"/config/images/gif_2.gif"}
              style={{ transform: "scaleX(-1)" }}
            />
          </s.Container>
          <Confetti active={ confetti } config={ config }/>
        </ResponsiveWrapper>
        <s.SpacerMedium />
        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>
          <StyledSecondButton alt={"logo"} src={"/config/images/button.png"} onClick={(e) => {window.open('https://www.youtube.com/watch?v=YTUofzW-csk&list=PLCyDnFfPKzVzvZcBZoCYcPZqE6i0P9KH0')}} />
        </s.Container>
      </s.Container>
    </s.Screen>
  );
}

export default App;
